/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of the given command. Might be null/undefined in case it's inactive or a group.
 * @export
 */
export const CommandTypeConstants = {
    RESTResource: 'RESTResource',
    HREF: 'HREF',
    JSFHREF: 'JSFHREF',
    FileDownload: 'FileDownload',
    ExternalHREF: 'ExternalHREF',
    Separator: 'Separator'
} as const;
export type CommandTypeConstants = typeof CommandTypeConstants[keyof typeof CommandTypeConstants];


export function CommandTypeConstantsFromJSON(json: any): CommandTypeConstants {
    return CommandTypeConstantsFromJSONTyped(json, false);
}

export function CommandTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommandTypeConstants {
    return json as CommandTypeConstants;
}

export function CommandTypeConstantsToJSON(value?: CommandTypeConstants | null): any {
    return value as any;
}

